import React, { useState, useEffect } from 'react';
import { StyleSheet /*Text, Platform*/ } from 'react-native';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarDays, faHeart, faHouseChimney, faUser, faBell } from '@fortawesome/free-solid-svg-icons';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { setRoute } from '../../store/portal/portalActions';
import { BLink, WebToolTip } from '../';
import { themeHeader } from '../../styles';

type props = {
  isBottom?: boolean;
};

export const FunctionalMenus = ({ isBottom = false }: props) => {
  const dispatch = useAppDispatch();
  const rtPortal = useAppSelector(s => s.portal);

  const [menuItemStyle, setMenuItemStyle] = useState<any>([]);
  const [menuItemIconStyle, setMenuItemIconStyle] = useState<any>({});

  useEffect(() => {
    if (isBottom) {
      setMenuItemStyle(themeHeader.bottom.menuItem);
      setMenuItemIconStyle(themeHeader.bottom.menuItemIcon);
    } else {
      setMenuItemStyle(themeHeader.menuItem);
      setMenuItemIconStyle(themeHeader.menuItemIcon);
    }
  }, []);

  return (
    <>
      {rtPortal.isSmallScreen && (
        <>
          <BLink style={menuItemStyle} to={{ screen: 'home' }} title="Home" onPress={() => dispatch(setRoute('home'))}>
            <FontAwesomeIcon
              icon={faHouseChimney}
              style={StyleSheet.flatten([
                menuItemIconStyle,
                rtPortal.mainRoute === 'home' ? themeHeader.iconSelected : null,
              ])}
              size={'xl'}
            />
          </BLink>
        </>
      )}
      <BLink
        style={menuItemStyle}
        to={{ screen: 'my-events' }}
        title="My Events"
        onPress={() => dispatch(setRoute('my-events'))}
      >
        <WebToolTip title={'My Events'}>
          <FontAwesomeIcon
            icon={faCalendarDays}
            style={StyleSheet.flatten([
              menuItemIconStyle,
              rtPortal.mainRoute === 'my-events' ? themeHeader.iconSelected : null,
            ])}
            size={'xl'}
          />
        </WebToolTip>
      </BLink>
      <BLink
        style={menuItemStyle}
        to={{ screen: 'my-favorites' }}
        title="My Favorites"
        onPress={() => dispatch(setRoute('my-favorites'))}
      >
        <WebToolTip title={'My Favorites'}>
          <FontAwesomeIcon
            icon={faHeart}
            style={StyleSheet.flatten([
              menuItemIconStyle,
              rtPortal.mainRoute === 'my-favorites' ? themeHeader.iconSelected : null,
            ])}
            size={'xl'}
          />
        </WebToolTip>
      </BLink>
      {/*<BLink
        style={menuItemStyle}
        to={{ screen: 'admin-portal' }}
        title="Admin Portal"
        onPress={() => dispatch(setRoute('admin-portal'))}
      >
        <FontAwesomeIcon
          icon={faPersonDigging}
          style={StyleSheet.flatten([
            menuItemIconStyle,
            rtPortal.mainRoute === 'admin-portal' ? themeHeader.iconSelected : null,
          ])}
          size={'xl'}
        />
        </BLink>*/}
      <BLink
        style={menuItemStyle}
        to={{ screen: 'my-notification' }}
        title="Notification"
        onPress={() => dispatch(setRoute('my-notification'))}
      >
        <FontAwesomeIcon
          icon={faBell}
          style={StyleSheet.flatten([
            menuItemIconStyle,
            rtPortal.mainRoute === 'my-notification' ? themeHeader.iconSelected : null,
          ])}
          size={'xl'}
        />
      </BLink>
      {rtPortal.isSmallScreen && (
        <BLink
          style={menuItemStyle}
          to={{ screen: 'my-settings' }}
          title="Account"
          onPress={() => dispatch(setRoute('my-settings'))}
        >
          <FontAwesomeIcon
            icon={faUser}
            style={StyleSheet.flatten([
              menuItemIconStyle,
              rtPortal.mainRoute === 'my-settings' ? themeHeader.iconSelected : null,
            ])}
            size={'xl'}
          />
        </BLink>
      )}
    </>
  );
};
